import { render, staticRenderFns } from "./EmailUpdate.vue?vue&type=template&id=b07ff0b4&"
import script from "./EmailUpdate.vue?vue&type=script&lang=js&"
export * from "./EmailUpdate.vue?vue&type=script&lang=js&"
import style0 from "./EmailUpdate.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports